import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'https://nutrition-app-backend-tibj.onrender.com/api';

const client = axios.create({
  baseURL: API_URL,
});

client.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

client.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      if (window.location.pathname !== '/login') {
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export const authAPI = {
  signup: (data) => client.post('/auth/signup', data),
  login: (data) => client.post('/auth/login', data),
};

export const usersAPI = {
  getProfile: () => client.get('/users/profile'),
  updateProfile: (data) => client.put('/users/profile', data),
};

export const mealsAPI = {
  addMeal: (data) => client.post('/meals/add', data),
  getCalendar: (year, month) => client.get(`/meals/calendar/${year}/${month}`),
  getDay: (date) => client.get(`/meals/day/${date}`),
  deleteMeal: (mealId) => client.delete(`/meals/${mealId}`),
};

export default client;
